import { nativePlatform, PttButton } from './native';
import { session } from './session';
import { getState, setState, updateSettings, useStore } from '../store';

/**
 * Bluetooth LE PTT button bridge (native apps only). Follows the "Bluetooth PTT button" setting:
 * starts the native plugin with the remembered button, remembers the first button it connects to,
 * and feeds presses into the session as the centre TALK key.
 */
let running = false;

function sync(): void {
  const { btPtt, btPttDevice } = getState().settings;
  if (btPtt && !running) {
    running = true;
    void PttButton.start({ deviceId: btPttDevice ?? undefined }).catch((err) => console.warn('PttButton.start failed', err));
  } else if (!btPtt && running) {
    running = false;
    void PttButton.stop().catch(() => undefined);
    setState({ btPttState: 'off', btPttName: null });
  }
}

/** Forget the remembered button and look for a new one. */
export async function forgetPttButton(): Promise<void> {
  updateSettings({ btPttDevice: null });
  if (!running) return;
  running = false;
  await PttButton.stop().catch(() => undefined);
  sync();
}

export function initPttButton(): void {
  if (nativePlatform() === 'web') return;
  void PttButton.addListener('state', (e) => {
    setState({ btPttState: e.state, btPttName: e.name ?? getState().btPttName });
    if (e.state === 'connected' && e.id && e.id !== getState().settings.btPttDevice) updateSettings({ btPttDevice: e.id });
  });
  void PttButton.addListener('ptt', (e) => void session.hardwarePtt(e.pressed));
  sync();
  useStore.subscribe((s, prev) => {
    if (s.settings.btPtt !== prev.settings.btPtt) sync();
  });
}
